import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const buttonV2Fn = /* @__PURE__ */ createRecipe('buttonV2', {
  "variant": "primary",
  "size": "md",
  "shape": "orignal"
}, [])

const buttonV2VariantMap = {
  "variant": [
    "primary",
    "outlined",
    "dashed",
    "default",
    "danger",
    "text",
    "link",
    "action",
    "tab"
  ],
  "size": [
    "sm",
    "md",
    "lg",
    "xl",
    "2xl",
    "icon",
    "tab"
  ],
  "shape": [
    "orignal",
    "default",
    "rounded",
    "circle",
    "oblong"
  ],
  "textStyle": [
    "uppercase",
    "normal"
  ],
  "width": [
    "full"
  ]
}

const buttonV2VariantKeys = Object.keys(buttonV2VariantMap)

export const buttonV2 = /* @__PURE__ */ Object.assign(memo(buttonV2Fn.recipeFn), {
  __recipe__: true,
  __name__: 'buttonV2',
  __getCompoundVariantCss__: buttonV2Fn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: buttonV2VariantKeys,
  variantMap: buttonV2VariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, buttonV2VariantKeys)
  },
  getVariantProps: buttonV2Fn.getVariantProps,
})